import { axios } from '@Root/API'

export const getByIndex = index => {
	return axios.get(`diocese/index/${index}`)
}
